import React from 'react';
import { formatCurrency } from '../../utils/formatters';
import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Contribution } from '../../types/crowdfunding';
// Icônes conservées, leur couleur sera modifiée par CSS
import { User, MessageCircle, Clock, HeartHandshake } from 'lucide-react';

interface ContributionsListProps {
  contributions: Contribution[];
  className?: string;
  showEmpty?: boolean;
}

export const ContributionsList: React.FC<ContributionsListProps> = ({
  contributions,
  className = '',
  showEmpty = true
}) => {
  // Cas où il n'y a aucun soutien, avec un message adapté
  if (contributions.length === 0 && showEmpty) {
    return (
      <div className={`bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 text-center ${className}`}>
        <HeartHandshake className="w-12 h-12 mx-auto text-red-500/30 mb-4" />
        <h3 className="text-lg font-semibold text-white">Aucun soutien pour le moment</h3>
        <p className="text-gray-400 mt-1">Devenez le premier mécène à inscrire votre nom dans l'histoire de cette œuvre.</p>
      </div>
    );
  }

  // Cas où il y a des soutiens à afficher
  return (
    <div className={`bg-transparent p-0 ${className}`}>
      <div className="space-y-4">
        {contributions.map((contribution) => (
          <div 
            key={contribution.id}
            className="bg-black/30 p-4 rounded-lg border border-white/10"
          >
            <div className="flex justify-between items-start">
              <div className="flex items-center">
                <div className="bg-red-900/50 rounded-full p-2.5 mr-4">
                  <User className="w-5 h-5 text-red-400" />
                </div>
                <div>
                  <p className="font-semibold text-white">
                    {contribution.is_anonymous 
                      ? 'Mécène Anonyme' 
                      : contribution.contributor_name || 'Un Mécène'}
                  </p>
                  <p className="text-sm text-gray-400 flex items-center mt-1">
                    <Clock className="w-3 h-3 mr-1.5" />
                    {formatDistanceToNow(new Date(contribution.created_at), { 
                      addSuffix: true,
                      locale: fr 
                    })}
                  </p>
                </div>
              </div>
              <div className="text-right flex-shrink-0 ml-2">
                <p className="font-bold text-lg text-red-400">{formatCurrency(contribution.amount)} FCFA</p>
                {/* Le statut du paiement n'est plus affiché car on ne montre que les paiements réussis ('paid') */}
              </div>
            </div>
            
            {contribution.message && (
              <div className="mt-3 pl-[52px] flex items-start">
                <MessageCircle className="w-4 h-4 text-gray-500 mr-2.5 mt-0.5 flex-shrink-0" />
                <p className="text-sm text-gray-300 italic bg-black/20 p-2 rounded-md w-full">"{contribution.message}"</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};